import React, {useState, useEffect} from "react";
import ChartExample from "../../components/ChartExample";
import DatePicker from "../../components/DatePicker";
import Header from "../../components/Header";
import API from "../../api/base_url";
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import BreadCumb from "../../components/BreadCumb";
import Footer from "../../components/Footer";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import ExportListRinseDrain from "../../components/ExportExcelRinseDrain/ExportListRinseDrain";
import ReactSpinner from "../../components/ReactSpinner";
import Moment from 'react-moment';



  const BackWash = () => {
  const token = localStorage.token;
  const headers = {
    Authorization: `Bearer ${token}`,
  };


  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    background:"#c51a1a",
    color:"#ffffff",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  let start =  moment().startOf('day').utc().format("YYYY-MM-DD HH:mm:ss")
  let end = moment().endOf('day').utc().format("YYYY-MM-DD HH:mm:ss")

  const columnsListBackwash = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "50px",
    },
    {
      name: "Name",
      cell: (row) => row.device_name,
    },
    {
      name: "Data & Time",
      cell: (row) => <Moment format="DD-MM-YYYY HH:mm:ss">{row.recorded_at}</Moment>,

    },
    {
      name: "Value",
      cell: (row) => `${row.value} m3`,
    },
    {
      name: "Device Parameter",
      cell: (row) => row.device_parameter,
    },
  ];

    const [site, setSite] = useState([]);
    const [pending, setPending] = useState(true);
    const [dateRangePickerValue, setDateRangePickerValue] = useState(`${start}/${end}`);
    const [dateRangePickerDisplay, setDateRangePickerDisplay] = useState(`${start}/${end}`);
  
    const [data, setData] = useState([])
    const [chartRinseDrainData, setChartRinseDrainData] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [errorMessage, setErrorMessage] = useState('')
    const handleErrorMessage = (message) => {
      setErrorMessage(message) // Update error message state from the child component
    }


    const getSite = () => {
    API.get("utility/master/data/site", { headers })
      .then(({ data: content }) => {
        setSite(content.data);
      })
      .catch((err) => {
        console.log(err);
      });
    };

    const getListData = () => {
      API.get(`report/rinse/drain/${dateRangePickerValue}`, { headers })
        .then(({ data: content }) => {
         setData(content.data.rinse_drain_1.report_device_value_history)
  
         let rinseDrainTmps = []
  
         content.data.rinse_drain_1.report_device_value_trend.forEach(el => {
          rinseDrainTmps.push({x:moment.utc(el.report_device_value_trend_time).local().format('DD/MM/YYYY HH:mm:ss'), y:el.report_device_value_trend_value})
         });
  
        setChartRinseDrainData(rinseDrainTmps);
        setPending(false)
        setIsLoading(false)
        })
        .catch((err) => {
          console.log(err);
        });
    }

    const handleFilterSubmit = () => {
      setData([])
      setChartRinseDrainData([])
      getListData()
    Toast.fire({
      icon: "success",
      title: "Filter Data Request",
    });
    }

    const setDateRangePickerValueFunc = (val) => {
    setDateRangePickerValue(val)
    }

    const setDateRangePickerValueExcelFunc = (val) => {
      setDateRangePickerDisplay(val)
     }

    useEffect(() => {
      getSite()
      getListData()
    }, [])

  return (
    <div id="wrap">
      {/* {isLoading ? <ReactSpinner/>: */}
        <div>
          <Header/>
          <BreadCumb pageRoot="Report & Analisis" name="Rinse and Drain" parent="/dashboard" subParent="/dashboard" underPage="Report Analisis" />
          
          <div className="container-fluid mt--6">
            <div className="card shadowTailwind">
              <div className="card-body">
                <div className="row">
                <div className="col-lg-12 d-flex">
                  <div className="col-lg-6">
                    <label className="form-control-label textPallete">Site</label>
                    <select
                      className="form-control text-darker"
                      id="channel"
                      name="channel"
                      data-toggle="select"
                      disabled
                      value={1}
                    >
                      {site.length === 0 ? (
                        <></>
                      ) : (
                        site.map((el, idx) => (
                          <option value={el.id} key={idx}>
                            {el.name}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-9">
                        <label className="form-control-label textPallete">Date Range</label>
                        <DatePicker
                          take={(val) => setDateRangePickerValueFunc(val)}
                          takeTimeExcel={(val) => setDateRangePickerValueExcelFunc(val)}
                          setErrorMessage={handleErrorMessage}
                        />
                        {/* Display the error message from the DatePicker */}
                        {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
                      </div>
                      <div className="col-lg-3">
                        <label className="form-control-label textPallete">&nbsp;</label> <br />
                        <button
                          className="btn bg-pallete text-white"
                          onClick={() => handleFilterSubmit()}
                          disabled={errorMessage.length > 0}
                        >
                          <span className="fa fa-search mr-2" /> Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>

   
          {/* Page content */}
          <div className="container-fluid">
            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="mb-0 text-red">Rinse & Drain 1</h4>
                    <ChartExample streaming={chartRinseDrainData} />
                  </div>
                  <div className="card-body">
                    <div className="mchart chartcss" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="col-lg-12 mt-5">
                  <div className="d-flex justify-content-between">
                    <h4 className="text-darker">List Total Data Rinse & Drain</h4>
                    <ExportListRinseDrain time={dateRangePickerDisplay} location={"Rinse & Drain 1"} data={data}/>
                  </div>
                  <DataTableExtensions
                    exportHeaders
                    print={false}
                    export={false}
                    columns={columnsListBackwash}
                    data={data}
                    filter={false}
                  >
                    <DataTable pagination progressPending={pending} />
                  </DataTableExtensions>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/* } */}
    </div>
  );
};

export default BackWash;
